import { useRef, useEffect, type MouseEventHandler } from 'react';

export const useScrollContainer = (center = false) => {
	const ref = useRef<HTMLDivElement>(null);
	const startX = useRef(0);
	const scrollLeft = useRef(0);
	const isMouseDown = useRef(false);

	const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
		isMouseDown.current = true;
		startX.current = e.pageX - e.currentTarget.offsetLeft;
		scrollLeft.current = e.currentTarget.scrollLeft;
	};

	const onMouseMove: MouseEventHandler<HTMLDivElement> = (e) => {
		if (!isMouseDown.current) return;
		e.preventDefault();
		const x = e.pageX - e.currentTarget.offsetLeft;
		const offset = x - startX.current;
		const left = scrollLeft.current - offset;
		e.currentTarget.scrollTo({ left, behavior: 'smooth' });
	};

	const setIsMouseUp: MouseEventHandler<HTMLDivElement> = () => {
		isMouseDown.current = false;
	};

	useEffect(() => {
		if (ref.current && center) {
			const left = (ref.current.scrollWidth - ref.current.clientWidth) / 2;
			ref.current.scrollTo({ left });
		}
	}, []);

	return { ref, onMouseDown, onMouseMove, onMouseUp: setIsMouseUp, onMouseLeave: setIsMouseUp };
};
